__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-08-03-1785755209-stable-dev/";